<template>
  <ElButton icon="el-icon-setting" @click="showHiddenAppsModal">
    {{ $t('APPS.HIDDEN_APPS.TITLE') }}
    <Hint :message="$t('HINTS.APPS.HIDDEN_APPS')" />
  </ElButton>
</template>

<script>
import Hint from '@@/common/Hint';
import HiddenAppsModal from '../modal/HiddenAppsModal';

export default {
  name: 'ShowHiddenAppsButton',
  components: { Hint },
  methods: {
    showHiddenAppsModal() {
      this.$modal
        .open({
          title: this.$t('APPS.HIDDEN_APPS.TITLE'),
          component: HiddenAppsModal,
          props: { ...this.$attrs },
          width: '35%',
        })
        .then(hiddenAppsChanged => {
          if (hiddenAppsChanged) {
            this.$emit('unhide');
          }
        });
    },
  },
};
</script>
